var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/url"] = t() : (e.wp = e.wp || {}, e.wp.url = t());
}(self, function () {
  return function () {
    "use strict";

    var e = {
      461: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.addQueryArgs = function addQueryArgs() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = arguments.length > 1 ? arguments[1] : void 0;
          if (!t || !Object.keys(t).length) return e;
          var r = e;
          var i = e.indexOf("?");
          -1 !== i && (t = Object.assign((0, n.getQueryArgs)(e), t), r = r.substr(0, i));
          return r + "?" + (0, u.buildQueryString)(t);
        };
        var n = r(712),
            u = r(222);
      },
      222: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.buildQueryString = function buildQueryString(e) {
          var t = "";
          var r = Object.entries(e);
          var n;

          for (; n = r.shift();) {
            var _n = n,
                _n2 = _slicedToArray(_n, 2),
                _e = _n2[0],
                u = _n2[1];

            if (Array.isArray(u) || u && u.constructor === Object) {
              var _t = Object.entries(u).reverse();

              var _iterator = _createForOfIteratorHelper(_t),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _step$value = _slicedToArray(_step.value, 2),
                      _n3 = _step$value[0],
                      _u = _step$value[1];

                  r.unshift(["".concat(_e, "[").concat(_n3, "]"), _u]);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            } else void 0 !== u && (null === u && (u = ""), t += "&" + [_e, u].map(encodeURIComponent).join("="));
          }

          return t.substr(1);
        };
      },
      962: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.cleanForSlug = function cleanForSlug(e) {
          if (!e) return "";
          return (0, n.trim)((0, n.deburr)(e).replace(/[\s\./]+/g, "-").replace(/[^\w-]+/g, "").toLowerCase(), "-");
        };
        var n = r(793);
      },
      261: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.filterURLForDisplay = function filterURLForDisplay(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              r = e.replace(/^(?:https?:)\/\/(?:www\.)?/, "");
          r.match(/^[^\/]+\/$/) && (r = r.replace("/", ""));
          var n = /([\w|:])*\.(?:jpg|jpeg|gif|png|svg)/;
          if (!t || r.length <= t || !r.match(n)) return r;
          r = r.split("?")[0];
          var u = r.split("/"),
              i = u[u.length - 1];
          if (i.length <= t) return "…" + r.slice(-t);
          var o = i.lastIndexOf("."),
              _ref = [i.slice(0, o), i.slice(o + 1)],
              l = _ref[0],
              c = _ref[1],
              a = l.slice(-3) + "." + c;
          return i.slice(0, t - a.length - 1) + "…" + a;
        };
      },
      666: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAuthority = function getAuthority(e) {
          var t = /^[^\/\s:]+:(?:\/\/)?\/?([^\/\s#?]+)[\/#?]{0,1}\S*$/.exec(e);
          if (t) return t[1];
        };
      },
      707: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFilename = function getFilename(e) {
          var t;

          try {
            t = new URL(e, "http://example.com").pathname.split("/").pop();
          } catch (e) {}

          if (t) return t;
        };
      },
      741: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFragment = function getFragment(e) {
          var t = /^\S+?(#[^\s\?]*)/.exec(e);
          if (t) return t[1];
        };
      },
      926: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getPathAndQueryString = function getPathAndQueryString(e) {
          var t = (0, n.getPath)(e),
              r = (0, n.getQueryString)(e);
          var u = "/";
          t && (u += t);
          r && (u += "?".concat(r));
          return u;
        };
        var n = r(268);
      },
      997: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getPath = function getPath(e) {
          var t = /^[^\/\s:]+:(?:\/\/)?[^\/\s#?]+[\/]([^\s#?]+)[#?]{0,1}\S*$/.exec(e);
          if (t) return t[1];
        };
      },
      662: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getProtocol = function getProtocol(e) {
          var t = /^([^\s:]+:)/.exec(e);
          if (t) return t[1];
        };
      },
      905: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getQueryArg = function getQueryArg(e, t) {
          return (0, n.getQueryArgs)(e)[t];
        };
        var n = r(712);
      },
      712: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getQueryArgs = function getQueryArgs(e) {
          return ((0, n.getQueryString)(e) || "").replace(/\+/g, "%20").split("&").reduce(function (e, t) {
            var _t$split$filter$map = t.split("=").filter(Boolean).map(decodeURIComponent),
                _t$split$filter$map2 = _slicedToArray(_t$split$filter$map, 2),
                r = _t$split$filter$map2[0],
                _t$split$filter$map2$ = _t$split$filter$map2[1],
                n = _t$split$filter$map2$ === void 0 ? "" : _t$split$filter$map2$;

            if (r) {
              !function setPath(e, t, r) {
                var n = t.length,
                    u = n - 1;

                for (var i = 0; i < n; i++) {
                  var _n4 = t[i];
                  !_n4 && Array.isArray(e) && (_n4 = e.length.toString());
                  var o = !isNaN(Number(t[i + 1]));
                  e[_n4] = i === u ? r : e[_n4] || (o ? [] : {}), Array.isArray(e[_n4]) && !o && (e[_n4] = _objectSpread({}, e[_n4])), e = e[_n4];
                }
              }(e, r.replace(/\]/g, "").split("["), n);
            }

            return e;
          }, {});
        };
        var n = r(257);
      },
      257: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getQueryString = function getQueryString(e) {
          var t;

          try {
            t = new URL(e, "http://example.com").search.substring(1);
          } catch (e) {}

          if (t) return t;
        };
      },
      912: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasQueryArg = function hasQueryArg(e, t) {
          return void 0 !== (0, n.getQueryArg)(e, t);
        };
        var n = r(905);
      },
      268: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "addQueryArgs", {
          enumerable: !0,
          get: function get() {
            return P.addQueryArgs;
          }
        }), Object.defineProperty(t, "buildQueryString", {
          enumerable: !0,
          get: function get() {
            return d.buildQueryString;
          }
        }), Object.defineProperty(t, "cleanForSlug", {
          enumerable: !0,
          get: function get() {
            return M.cleanForSlug;
          }
        }), Object.defineProperty(t, "filterURLForDisplay", {
          enumerable: !0,
          get: function get() {
            return A.filterURLForDisplay;
          }
        }), Object.defineProperty(t, "getAuthority", {
          enumerable: !0,
          get: function get() {
            return l.getAuthority;
          }
        }), Object.defineProperty(t, "getFilename", {
          enumerable: !0,
          get: function get() {
            return S.getFilename;
          }
        }), Object.defineProperty(t, "getFragment", {
          enumerable: !0,
          get: function get() {
            return p.getFragment;
          }
        }), Object.defineProperty(t, "getPath", {
          enumerable: !0,
          get: function get() {
            return a.getPath;
          }
        }), Object.defineProperty(t, "getPathAndQueryString", {
          enumerable: !0,
          get: function get() {
            return y.getPathAndQueryString;
          }
        }), Object.defineProperty(t, "getProtocol", {
          enumerable: !0,
          get: function get() {
            return i.getProtocol;
          }
        }), Object.defineProperty(t, "getQueryArg", {
          enumerable: !0,
          get: function get() {
            return m.getQueryArg;
          }
        }), Object.defineProperty(t, "getQueryArgs", {
          enumerable: !0,
          get: function get() {
            return j.getQueryArgs;
          }
        }), Object.defineProperty(t, "getQueryString", {
          enumerable: !0,
          get: function get() {
            return f.getQueryString;
          }
        }), Object.defineProperty(t, "hasQueryArg", {
          enumerable: !0,
          get: function get() {
            return _.hasQueryArg;
          }
        }), Object.defineProperty(t, "isEmail", {
          enumerable: !0,
          get: function get() {
            return u.isEmail;
          }
        }), Object.defineProperty(t, "isURL", {
          enumerable: !0,
          get: function get() {
            return n.isURL;
          }
        }), Object.defineProperty(t, "isValidAuthority", {
          enumerable: !0,
          get: function get() {
            return c.isValidAuthority;
          }
        }), Object.defineProperty(t, "isValidFragment", {
          enumerable: !0,
          get: function get() {
            return b.isValidFragment;
          }
        }), Object.defineProperty(t, "isValidPath", {
          enumerable: !0,
          get: function get() {
            return s.isValidPath;
          }
        }), Object.defineProperty(t, "isValidProtocol", {
          enumerable: !0,
          get: function get() {
            return o.isValidProtocol;
          }
        }), Object.defineProperty(t, "isValidQueryString", {
          enumerable: !0,
          get: function get() {
            return g.isValidQueryString;
          }
        }), Object.defineProperty(t, "normalizePath", {
          enumerable: !0,
          get: function get() {
            return U.normalizePath;
          }
        }), Object.defineProperty(t, "prependHTTP", {
          enumerable: !0,
          get: function get() {
            return h.prependHTTP;
          }
        }), Object.defineProperty(t, "removeQueryArgs", {
          enumerable: !0,
          get: function get() {
            return O.removeQueryArgs;
          }
        }), Object.defineProperty(t, "safeDecodeURI", {
          enumerable: !0,
          get: function get() {
            return v.safeDecodeURI;
          }
        }), Object.defineProperty(t, "safeDecodeURIComponent", {
          enumerable: !0,
          get: function get() {
            return Q.safeDecodeURIComponent;
          }
        });

        var n = r(799),
            u = r(449),
            i = r(662),
            o = r(324),
            l = r(666),
            c = r(534),
            a = r(997),
            s = r(808),
            f = r(257),
            d = r(222),
            g = r(396),
            y = r(926),
            p = r(741),
            b = r(52),
            P = r(461),
            m = r(905),
            j = r(712),
            _ = r(912),
            O = r(514),
            h = r(552),
            v = r(264),
            Q = r(120),
            A = r(261),
            M = r(962),
            S = r(707),
            U = r(856);
      },
      449: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isEmail = function isEmail(e) {
          return r.test(e);
        };
        var r = /^(mailto:)?[a-z0-9._%+-]+@[a-z0-9][a-z0-9.-]*\.[a-z]{2,63}$/i;
      },
      799: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isURL = function isURL(e) {
          try {
            return new URL(e), !0;
          } catch (_unused) {
            return !1;
          }
        };
      },
      534: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidAuthority = function isValidAuthority(e) {
          if (!e) return !1;
          return /^[^\s#?]+$/.test(e);
        };
      },
      52: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidFragment = function isValidFragment(e) {
          if (!e) return !1;
          return /^#[^\s#?\/]*$/.test(e);
        };
      },
      808: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidPath = function isValidPath(e) {
          if (!e) return !1;
          return /^[^\s#?]+$/.test(e);
        };
      },
      324: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidProtocol = function isValidProtocol(e) {
          if (!e) return !1;
          return /^[a-z\-.\+]+[0-9]*:$/i.test(e);
        };
      },
      396: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidQueryString = function isValidQueryString(e) {
          if (!e) return !1;
          return /^[^\s#?\/]+$/.test(e);
        };
      },
      856: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.normalizePath = function normalizePath(e) {
          var t = e.split("?"),
              r = t[1],
              n = t[0];
          if (!r) return n;
          return n + "?" + r.split("&").map(function (e) {
            return e.split("=");
          }).sort(function (e, t) {
            return e[0].localeCompare(t[0]);
          }).map(function (e) {
            return e.join("=");
          }).join("&");
        };
      },
      552: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prependHTTP = function prependHTTP(e) {
          if (!e) return e;
          if (e = e.trim(), !u.test(e) && !(0, n.isEmail)(e)) return "http://" + e;
          return e;
        };
        var n = r(449);
        var u = /^(?:[a-z]+:|#|\?|\.|\/)/i;
      },
      514: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.removeQueryArgs = function removeQueryArgs(e) {
          var t = e.indexOf("?");
          if (-1 === t) return e;
          var r = (0, n.getQueryArgs)(e),
              i = e.substr(0, t);

          for (var o = arguments.length, l = new Array(o > 1 ? o - 1 : 0), c = 1; c < o; c++) {
            l[c - 1] = arguments[c];
          }

          l.forEach(function (e) {
            return delete r[e];
          });
          var a = (0, u.buildQueryString)(r);
          return a ? i + "?" + a : i;
        };
        var n = r(712),
            u = r(222);
      },
      120: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.safeDecodeURIComponent = function safeDecodeURIComponent(e) {
          try {
            return decodeURIComponent(e);
          } catch (t) {
            return e;
          }
        };
      },
      264: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.safeDecodeURI = function safeDecodeURI(e) {
          try {
            return decodeURI(e);
          } catch (t) {
            return e;
          }
        };
      },
      793: function _(e) {
        e.exports = require("lodash");
      }
    },
        t = {};

    var r = function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var u = t[r] = {
        exports: {}
      };
      return e[r](u, u.exports, __webpack_require__), u.exports;
    }(268);

    return r;
  }();
});